import createLogger from '@techstyle/debug';

export default createLogger('@techstyle/browser-support');
